export const changeTabActive = (data) => ({
  type: "ACTIVE_TAB",
  payload: data,
});
